import React, { Component } from "react";
import { View, ScrollView } from 'react-native'
import { connect } from 'react-redux';
import {Header,SuccessAvatar,WCTaskPaper, WCRiddlePaper, ProgressPaper,Label,ProgressStrength,MemberProgress} from "../../../components/SharedComponents";
import actions from '../../../actions';
import styles from "../../../shared/styles";
import { colors, global } from "../../../utils";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import localize from "../../../shared/localize";

const  { currentStrangth, getMemberDailyProcess, getDailyTask, getDailyRiddleQuestion, showLoader, hideLoader }=actions;

class DailyProgress extends Component {

    componentDidMount() {
        this._userDailyprogress();
    }

    _userDailyprogress = async () => {
        this.props.showLoader();
        await this.props.currentStrangth()
        await this.props.getDailyTask()
        await this.props.getDailyRiddleQuestion()
        await this.props.getMemberDailyProcess()
        this.props.hideLoader();
    }

    _navigate = (pathname, state, search) => {
        return this.props.history.push({
            pathname,
            state,
            search
        });
    }

    renderItem = (item, i) => {
        return <MemberProgress item={item} key={String(i)} />
    }

    render() {
        const { userInfo, setting, daily_task, daily_riddle, members_progress, app } = this.props;
        let { height, familyStrenght } = setting;
        let strength = (familyStrenght.strength / 10);

        return (
            <View style={styles.container}>
                <Header title={localize.daily_progress} right={(
                    <Icon
                        color={colors.white}
                        icon={faCog}
                        style={{ position: "static", fontSize: 20, marginRight: 10 }}
                        onClick={() => this._navigate("settings")}
                    />
                )} />
                <ScrollView style={{ height: height - 130 }}>

                    {/* {
                        app === "dv" && (
                            <> */}
                                <View style={{ flexDirection: "row", justifyContent: "space-between", paddingHorizontal: 20 }}>
                                    {this.doneTask(daily_task, localize.daily_task)}
                                    {this.doneTask(daily_riddle, localize.daily_riddle)}
                                </View>
                                <WCTaskPaper handleClick={this._navigate} />
                                <WCRiddlePaper handleClick={this._navigate} />
                            {/* </>
                        )
                    } */}

                    {/* {(this.props.isEnableEnglish === true || app === "ev") && (
                        <>
                            <ProgressPaper
                                title={localize.statistics}
                                description={localize.we_widget_body}
                                buttonTitle={localize.details}
                                buttonAction={() => this._navigate("/statistics")}
                            />
                            <ProgressPaper
                                title={localize.homework}
                                description={localize.hw_widget_body}
                                buttonTitle={localize.go}
                                buttonAction={() => this._navigate("/homework")}
                            />
                        </>
                    )} */}

                    <View style={{ marginTop: 18, paddingHorizontal: 20 }}>
                        {
                            userInfo.family_name !== '' ?
                                <ProgressStrength
                                    progress={strength}
                                    start={familyStrenght.maxLevel}
                                    end={familyStrenght.minLevel}
                                    title={localize.formatString(localize.family_strength, userInfo.family_name)}
                                    onPress={() => this._navigate("/dashboard/progress", { type: 1, id: familyStrenght.family_id })}
                                />
                                : null
                        }
                        <View style={styles.divider} />
                        {
                            userInfo.family_name === "" && (
                                <View style={{ padding: 20 }}>
                                    <Label.PrimarySubtitle align="center">
                                        {localize.You_need_to_add_family_members_who_will_show_up_in_this_space}
                                    </Label.PrimarySubtitle>
                                </View>
                            )
                        }
                        {
                            members_progress && members_progress.length > 0 && (
                                <View style={{ paddingTop: 20 }}>
                                    <View style={{ flexDirection: 'row' }}>
                                        <View style={{ flex: 0.8 }} />
                                        <View style={{ flex: 0.2 }}>
                                            <Label.PrimaryCaption>{localize.daily}</Label.PrimaryCaption>
                                            <Label.PrimaryCaption>{localize.task}</Label.PrimaryCaption>
                                        </View>
                                        <View style={{ flex: 0.2 }}>
                                            <Label.PrimaryCaption>{localize.daily}</Label.PrimaryCaption>
                                            <Label.PrimaryCaption>{localize.riddle}</Label.PrimaryCaption>
                                        </View>
                                    </View>
                                    {members_progress.map(this.renderItem)}
                                </View>
                            )
                        }
                    </View>
                </ScrollView>
            </View>
        )
    };

    doneTask = (task, title) => {
        if (task && task.status === 201)
            return (
                <View style={{ flexDirection: "row", alignItems: "center", marginVertical: 20 }}>
                    <SuccessAvatar size={26} />
                    <View style={{ marginLeft: 10 }}>
                        <Label.PrimaryCaption weight="bold">{title}</Label.PrimaryCaption>
                    </View>
                </View>
            )
        return null;
    }

}

const mapStateToProps = ({ setting, auth, main }) => {
    return {
        setting: setting,
        userInfo: auth.userInfo,
        // isEnableEnglish: setting.isEnableEnglish,
        daily_task: main.daily_task,
        daily_riddle: main.daily_riddle,
        members_progress: main.members_progress
    }
}
export default connect(mapStateToProps, { getDailyTask, getDailyRiddleQuestion, getMemberDailyProcess, currentStrangth, showLoader, hideLoader })(DailyProgress);